import React from 'react';
// import Explorer from '../../../../data-containers/explorer';

export default function() {
  return <></>;
  // const { dateRange, setDateRange } = Explorer.useContainer();

  // const onClick = range => {
  //   return e => {
  //     e.preventDefault();
  //     setDateRange(range);
  //   }
  // }
  
  // return <div className="date-range">
  //   <span className="label">Range: </span>
  //   <a
  //     className={`${dateRange === '1d' ? 'active' : ''}`}
  //     onClick={onClick('1d')}>Last 24 hours</a>
  //   <a
  //     className={`${dateRange === '30d' ? 'active' : ''}`}
  //     disabled={true}>Last 30 days</a>
  // </div>
}
